import { match } from "ts-pattern";
import { ControlDataTypeKey, Types, Schema } from "../prop-controllers";
import { z } from "zod";
const textStyleDataSchema = z.object({
  fontFamily: z.string().optional().nullable(),
  letterSpacing: z.number().optional().nullable(),
  fontSize: z.object({
    value: z.number(),
    unit: z.literal("px")
  }).optional().nullable(),
  fontWeight: z.number().optional().nullable(),
  textTransform: z.array(z.literal("uppercase")),
  fontStyle: z.array(z.literal("italic"))
}).transform((v) => ({
  ...v,
  letterSpacing: v.letterSpacing,
  fontSize: v.fontSize,
  fontWeight: v.fontWeight,
  textTransform: v.textTransform,
  fontStyle: v.fontStyle
}));
const responsiveTextStyleDataSchema = Schema.responsiveValue(textStyleDataSchema);
const textStylePropControllerDataV0Schema = responsiveTextStyleDataSchema;
const TextStylePropControllerDataV1Type = "prop-controllers::text-style::v1";
const textStylePropControllerDataV1Schema = z.object({
  [ControlDataTypeKey]: z.literal(TextStylePropControllerDataV1Type),
  value: responsiveTextStyleDataSchema
});
const textStylePropControllerDataSchema = z.union([
  textStylePropControllerDataV0Schema,
  textStylePropControllerDataV1Schema
]);
function TextStyle(options = {}) {
  return { type: Types.TextStyle, version: 1, options };
}
function getTextStylePropControllerDataResponsiveTextStyleData(data) {
  return match(data).with(
    { [ControlDataTypeKey]: TextStylePropControllerDataV1Type },
    (v1) => v1.value
  ).otherwise((v0) => v0);
}
function createTextStylePropControllerDataFromResponsiveTextStyleData(responsiveTextStyleData, definition) {
  return match(definition).with(
    { version: 1 },
    () => ({
      [ControlDataTypeKey]: TextStylePropControllerDataV1Type,
      value: responsiveTextStyleData
    })
  ).otherwise(() => responsiveTextStyleData);
}
export {
  TextStyle,
  TextStylePropControllerDataV1Type,
  createTextStylePropControllerDataFromResponsiveTextStyleData,
  getTextStylePropControllerDataResponsiveTextStyleData,
  textStyleDataSchema,
  textStylePropControllerDataSchema
};
//# sourceMappingURL=text-style.js.map